
import Swal from "sweetalert2";
import { translate } from '@/i18n'
import 'sweetalert2/dist/sweetalert2.min.css'
import { useFetchWithFiles } from "@/composables/useFetchWithFiles";

export function notificationImportPeopleFinished(data) {
    swalFire(data)
}

async function swalFire(data) {
    const records = await getRecords(data)
    const html = textPreprocess(records)
    Swal.fire({
        title: translate('Import Personas Finished'),
        icon: isInformativeOrErrors(records),
        html: html,
        showCloseButton: true,
        showClass: {
            popup: 'animate__animated animate__slideInDown',
        },
    })
}

async function getRecords(pusher) {
    const {data, success} = await useFetchWithFiles(pusher.record_url, {}, 'GET')
    return data
}

 function textPreprocess(data) {
    const errors =  getErrors(data)
    let html = ''
    if (errors.length > 0) {
        html = convertErrorsToHTML(errors)
    }
    return html
}

 function isInformativeOrErrors(data) {
    const errors = data.data.errors
    if (errors.length > 0) return 'error'
    return 'info'
}

 function getErrors(data) {
    const errors = []

    data.data.errors.forEach(element => {
        const elementErrors = []
        for (const error in element.errors) {
            const errores = element.errors[error]
            const messages = errores.map((mensaje) => {
                return mensaje.replace(/basic\./g, '').replace(/custom\./g, '');
            })
            elementErrors.push(...messages)
        }
        const error = {
            email: element.persona_data.basic.email,
            errors: elementErrors
        }
        errors.push(error)
    })
    return errors
}

function convertErrorsToHTML(errors) {
    let html = `<p class="swal-longmessage">${translate('The following records could not be imported into the database')}:</p><div style="max-height: 30vh;"><ul class="swal-longmessage">`;

    errors.forEach((error, index) => {
        html += `<li class="swal-longmessage">${error.email}<ul>`;
        error.errors.forEach((errorMessage) => {
            html += `<li class="swal-longmessage">${translate(errorMessage)}</li>`;
        });
        html += '</ul></li>';
    });

    html += '</ul></div>';

    return html;
}

